import { parseMatrixAnswerRows } from '@/shared-project-insights';
import { serializeMatrixAnswer } from '@/shared-question-model';

export type MatrixSelection = Readonly<Record<string, string>>;

interface MatrixRow {
  readonly id: string;
}

export function parseMatrixSelection(
  rawValue: string | null | undefined
): MatrixSelection {
  if (!rawValue) return {};

  return Object.fromEntries(
    parseMatrixAnswerRows(rawValue, []).map((row) => [row.id, row.value])
  );
}

export function isMatrixSelectionComplete(
  rows: ReadonlyArray<MatrixRow>,
  selection: MatrixSelection
): boolean {
  return rows.length > 0 && rows.every((row) => Boolean(selection[row.id]));
}

export function toMatrixAnswerContent(
  rows: ReadonlyArray<MatrixRow>,
  selection: MatrixSelection
): string {
  if (!isMatrixSelectionComplete(rows, selection)) return '';

  return serializeMatrixAnswer(
    rows.map((row) => ({ sqId: row.id, v: selection[row.id] }))
  );
}
